/**
 * Build colored SearchableSelect options for Static Tags — each tag renders as
 * its colored chip in the dropdown (and on the trigger). Shared by the
 * Scheduler tag filter and the per-campaign tag picker.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { SearchableSelectOption } from '@/components/ui';
import { StaticTagBadge } from '@/features/smswiser-campaigns/components/drop-modals/sections/StaticTagBadge';

export interface TagLike {
  id: string;
  name: string;
  color: string;
}

/** A single tag as a colored-chip option. */
export function tagOption(tag: TagLike): SearchableSelectOption<string> {
  return {
    value: tag.id,
    label: tag.name,
    optionContent: <StaticTagBadge name={tag.name} color={tag.color} />,
  };
}

/** Colored tag options, optionally prefixed with plain sentinel options. */
export function tagSelectOptions(
  tags: ReadonlyArray<TagLike>,
  leading: SearchableSelectOption<string>[] = [],
): SearchableSelectOption<string>[] {
  return [...leading, ...tags.map(tagOption)];
}
